<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>
    <div class="page-wrapper">
      <div class="content container-fluid">

        <!-- Page Header -->
        <div class="page-header">
          <div class="row">
            <div class="col">
              <h3 class="page-title">Service Providers</h3>
            </div>
          </div>
        </div>
        <!-- /Page Header -->

        <!-- Search Filter -->
        <div v-if="showFilters" class="card filter-card" id="filter-inputs">
          <div class="card-body pb-0">
            <form>
              <div class="row filter-row">
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label>Name</label>
                    <input class="form-control" type="text" v-model="filters.name">
                  </div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label>Email</label>
                    <input class="form-control" type="text" v-model="filters.email">
                  </div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label>Phone</label>
                    <input class="form-control" type="text" v-model="filters.phone">
                  </div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <button class="btn btn-primary btn-block" type="button" @click="retrieveContractors">Search</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!-- /Search Filter -->

        <div ref="contractorsContainer" class="row vld-parent">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-12 col-md-0">
                  </div>
                  <div class="col-sm-12 col-md-12">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <select
                          class="input-group-text form-control bg-primary"
                          v-model="selectedSearchFilterId"
                          @change="changeSearchFilter"
                          :required="true">
                          <option
                            v-for="searchFilter in searchFilters"
                            :key="searchFilter"
                            :value="searchFilter"
                            :name="searchFilter"
                            :selected="searchFilter">
                            {{ searchFilter }}
                          </option>
                        </select>
                      </div>
                      <input class="form-control" type="text" v-model="searchValue"
                             @keyup="searchContractors($event)" placeholder="Search service providers...">
                    </div>
                  </div>
                </div>
                <hr/>
                <div class="table-responsive">
                  <table id="tblContractors" class="table table-hover table-center mb-0"
                         :class="windowWidth < 768 ? 'cards': '-'">
                    <thead style="background-color: ghostwhite">
                    <tr class="text-center">
                      <th scope="col" class="text-left">Code</th>
                      <th scope="col" class="text-left">Name</th>
                      <th scope="col" class="text-left">Category</th>
                      <th scope="col" class="text-left">Status</th>
                      <th scope="col" class="text-right">Action</th>
                    </tr>
                    </thead>
                    <tbody v-if="contractors.length">
                    <tr class="text-center" v-for="contractor in contractors" :key="contractor.id">
                      <td col="Code: " class="text-left">{{ contractor.code ? contractor.code : '-' }}</td>
                      <td col="Name: " class="text-left">{{ contractor.name ? contractor.name : '-' }}</td>
                      <td col="Category: " class="text-left">{{ contractor.category ? contractor.category : '-' }}</td>
                      <td col="Status: " class="text-left">
                        <label v-if="contractor.status === 'ACTIVE'" class="badge badge-success">ACTIVE</label>
                        <label v-else-if="contractor.status === 'INACTIVE'" class="badge badge-secondary">INACTIVE</label>
                        <label v-else class="badge badge-secondary">{{ contractor.status }}</label>
                      </td>
                      <td class="text-right">
                        <a class="btn btn-success" id="showBookContractorModal" data-toggle="modal"
                           href="#book_contractor_modal" hidden></a>
                        <button @click="bookContractor(contractor)"
                                class="btn btn-sm btn-success book-button" :class="windowWidth < 768 ? 'btn btn-block': '-'">
                          <i class="fa fa-calendar mr-1"></i> Book
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="!contractors.length" class="text-center mt-5 mb-5">
                  <div>You don't have any service providers yet</div>
                </div>
                <div v-if="contractors.length" class="row">
                  <div class="col-sm-12 col-md-5">
                    <div class="" id="tblProducts_info" contractor="status" aria-live="polite"
                         style="padding-top: 1.25em">
                      Show
                      <select @change="onChangeRecordsPerPage" v-model="recordsPerPage">
                        <option :value="5">5</option>
                        <option :value="10">10</option>
                        <option :value="20">20</option>
                        <option :value="30">30</option>
                        <option :value="40">40</option>
                        <option :value="50">50</option>
                      </select>
                      of {{ totalRecords }} entries
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-7">
                    <div class="dataTables_paginate paging_simple_numbers" id="tblProducts_paginate"
                         style="padding-top: 0.55em">
                      <pagination
                        :totalPages="totalPages"
                        :perPage="recordsPerPage"
                        :currentPage="currentPage"
                        @pagechanged="onPageChange"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Create Contractor Modal -->
        <div class="modal fade" id="create_contractor_modal" aria-hidden="true" role="dialog">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header bg-primary">
                <h5 class="modal-title">Create {{ $t("sidebar.contractor") }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <CreateContractorForm/>
              </div>
            </div>
          </div>
        </div>
        <!-- Create Contractor Modal -->

        <!-- Create Contractor Modal -->
        <div class="modal fade" id="associate_customer_modal" aria-hidden="true" role="dialog">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header bg-primary">
                <h5 class="modal-title">Add {{ $t("sidebar.customer") }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <AssociateCustomer :cus-id="contractorId"/>
              </div>
            </div>
          </div>
        </div>
        <!-- Create Contractor Modal -->

        <!-- Edit Contractor Modal -->
        <div class="modal fade" id="edit_contractor_modal" aria-hidden="true" role="dialog" ref="modal">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header bg-primary">
                <h5 class="modal-title">Create {{ $t("sidebar.contractor") }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form action="">
                  <div>
                    <div class="form-group">
                      <label>{{ $t("sidebar.contractor") }} Number</label>
                      <input readonly type="text" class="form-control" v-model="contractor.code" ref="contractorNumber"
                             placeholder="">
                    </div>
                    <div class="form-group">
                      <label>First Name</label>
                      <input type="text" class="form-control" v-model="contractor.firstName">
                    </div>
                    <div class="form-group">
                      <label>Last Name</label>
                      <input type="text" class="form-control" v-model="contractor.lastName">
                    </div>
                    <div class="form-group">
                      <label>ID No.</label>
                      <input type="text" class="form-control" v-model="contractor.idNumber">
                    </div>
                    <div class="form-group">
                      <label>Email</label>
                      <input type="text" class="form-control" v-model="contractor.email" readonly>
                    </div>
                    <div class="form-group">
                      <label>Phone</label>
                      <input type="text" class="form-control" v-model="contractor.phone">
                    </div>
                    <div class="form-group">
                      <label>Address</label>
                      <input type="text" class="form-control" v-model="contractor.address">
                    </div>
                    <div class="mt-4">
                      <button class="btn btn-primary btn-block" @click="updateContractor($event)">Submit</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- Edit Contractor Modal -->

        <!-- Book Contractor Modal -->
        <div class="modal fade" id="book_contractor_modal" aria-hidden="true" role="dialog">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header bg-primary">
                <h5 class="modal-title">Book Service Provider</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form action="">
                  <div class="form-group">
                    <label>Service Provider</label>
                    <input readonly type="text" class="form-control" :value="selectedContractor ? selectedContractor.name : ''">
                  </div>

                  <div class="form-group">
                    <label>Number of People</label>
                    <input type="number" class="form-control" v-model="booking.numberOfPeople" min="1" placeholder="Enter number of people">
                  </div>

                  <div class="form-group">
                    <label>Vehicle Registration</label>
                    <input type="text" class="form-control" v-model="booking.vehicleRegistration" placeholder="Enter vehicle registration">
                  </div>

                  <div style="display: flex; gap: 10px">
                    <div class="form-group">
                      <label>Start Date</label>
                      <date-picker style="width: 100%" v-model="booking.startDate" valueType="format" type="date"
                                   input-class="form-control"></date-picker>
                    </div>
                    <div class="form-group">
                      <label>Start Time</label>
                      <date-picker style="width: 100%" v-model="booking.startTime" valueType="format" type="time"
                                   format="HH:mm" input-class="form-control"></date-picker>
                    </div>
                  </div>

                  <div style="display: flex; gap: 10px">
                    <div class="form-group">
                      <label>End Date</label>
                      <date-picker style="width: 100%" v-model="booking.endDate" valueType="format" type="date"
                                   input-class="form-control"></date-picker>
                    </div>
                    <div class="form-group">
                      <label>End Time</label>
                      <date-picker style="width: 100%" v-model="booking.endTime" valueType="format" type="time"
                                   format="HH:mm" input-class="form-control"></date-picker>
                    </div>
                  </div>

                  <div class="mt-4">
                    <button class="btn btn-primary btn-block" @click="saveBooking($event)" :disabled="savingBooking">
                      <span v-if="savingBooking">
                        <i class="fas fa-spinner fa-spin"></i> Saving...
                      </span>
                      <span v-else>Submit</span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- Book Contractor Modal -->
      </div>
    </div>
  </div>
  <!-- /Main Wrapper -->
</template>

<script>
import * as contractorService from "../../service/contractor.service";
import Pagination from "../Pagination";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import visitService from "../../service/appointment.service";

export default {
  name: "contractors",
  components: {
    Pagination,
    // CreateContractorForm,
    // EditContractorForm,
    DatePicker,
  },
  data() {
    return {
      contractorId: null,
      contractor: {},
      contractors: [],
      selectedContractor: null,
      booking: {
        numberOfPeople: 1,
        vehicleRegistration: undefined,
        startDate: undefined,
        endDate: undefined,
        startTime: undefined,
        endTime: undefined,
      },
      savingBooking: false,
      currentIndex: -1,
      title: "",
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
      recordsPerPage: 10,
      showFilters: false,
      filters: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null
      },
      searchValue: "",
      searchFilters: ["Name", "Category"],
      selectedSearchFilterId: "Name",
      fullPage: false,
      isMobileView: false,
      isTabletView: false,
      isDesktopView: false
    };
  },
  methods: {
    getCurrentDate() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
      const day = currentDate.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`
    },
    getDefaultTime() {
      const date = new Date();
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      return `${hours}:${minutes}`
    },
    bookContractor(contractor) {
      this.selectedContractor = contractor;
      this.booking.startDate = this.getCurrentDate();
      this.booking.endDate = this.getCurrentDate();
      this.booking.startTime = this.getDefaultTime();
      this.booking.endTime = this.getDefaultTime();
      document.getElementById('showBookContractorModal').click();
    },
    saveBooking(e) {
      e.preventDefault();
      
      if (!this.selectedContractor) {
        this.fireNotification('error', "Error", "No service provider selected");
        return;
      }

      const contextId = localStorage.getItem('contextId') || localStorage.getItem('selectedContextId');
      const personBeingVisitedId = localStorage.getItem('actorId');

      if (!contextId) {
        this.fireNotification('error', "Error", "Customer context not found. Please log in again.");
        return;
      }

      this.savingBooking = true;

      let appointment = {
        bookingType: 'CONTRACTOR',
        contractorId: this.selectedContractor.id,
        name: this.selectedContractor.name,
        destinationId: contextId,
        personBeingVisitedId: personBeingVisitedId,
        numberOfPeople: this.booking.numberOfPeople,
        vehicleRegistration: this.booking.vehicleRegistration,
        startDate: this.booking.startDate,
        endDate: this.booking.endDate,
        startTime: this.booking.startTime + ':00+00:00',
        endTime: this.booking.endTime + ':00+00:00'
      }
      
      visitService.create(contextId, appointment)
        .then(response => {
          let code = response.data.code;
          if (code === 'SUCCESS') {
            const visitId = response.data.data.id;
            document.getElementById('showBookContractorModal').click();
            this.$router.push(`/visits/${visitId}`);
            Swal.fire({
              icon: 'success',
              title: 'Done',
              text: "Successfully booked service provider",
              footer: '<a href="">Why do I have this issue?</a>'
            });
          } else {
            this.fireNotification('warning', "", response.data.narrative);
          }
        })
        .catch(e => {
          console.log(e);
          if (e.response && (e.response.status === 401 || e.response.status === 403 || e.response.status === 409)) {
            return
          }
          this.fireNotification('error', "Oops", "Error occurred");
        })
        .finally(() => {
          this.savingBooking = false;
        });
    },
    toggleShowFilters() {
      this.showFilters = !this.showFilters;
    },
    changeSearchFilter() {
      this.searchContractors(null)
    },
    viewContractor(id) {
      this.$router.push(`/contractors/${id}`);
    },
    editContractor(id) {
      this.contractorId = id
      this.retrieveContractor(id)
      document.getElementById('showEditContractorModal').click()
    },
    associateCustomer(id) {
      this.contractorId = id
      this.retrieveContractor(id)
      document.getElementById('showAssociateCustomerModal').click()
    },
    retrieveContractor(id) {
      contractorService.findById(localStorage.getItem('mid'), id)
        .then(response => {
          this.contractor = response.data.data;
        })
        .catch(e => {
          console.log(e);
          if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
            return
          }
          this.fireNotification('error', 'Oops', "Error occurred")
        });
    },
    retrieveContractors() {
      let loader = this.$loading.show({
        container: this.$refs.contractorsContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      const customerId = localStorage.getItem('contextId') || localStorage.getItem('selectedContextId');
      let params = {
        page: this.currentPage,
        size: this.recordsPerPage,
        types: 'CONTRACTOR'
      }
      contractorService.findByCustomerId(customerId, params)
        .then(response => {
          this.contractors = response.data.data.sort((a, b) => (a.name > b.name) ? 1 : -1)
          this.totalPages = response.data.pagination ? response.data.pagination.totalPages : 0
          this.totalRecords = response.data.pagination ? response.data.pagination.totalRecords : 0
        })
        .catch(e => {
          console.log('Error:', e)
          if (e.response && (e.response.status === 401 || e.response.status === 403 || e.response.status === 409)) {
            return
          }
          this.fireNotification('error', "Error occurred", 5000)
        })
        .finally(() => {
          loader.hide()
        });
    },
    searchContractors(e) {
      e ? e.preventDefault() : null
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.contractorsContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      const customerId = localStorage.getItem('contextId') || localStorage.getItem('selectedContextId');
      let params = {
        page: this.currentPage,
        size: this.recordsPerPage,
        types: 'CONTRACTOR',
        op: 'like'
      }
      if (this.searchValue) {
        params[this.selectedSearchFilterId.toLowerCase()] = this.searchValue;
      }
      contractorService.findByCustomerId(customerId, params)
        .then(response => {
          this.contractors = response.data.data;
          this.totalPages = response.data.pagination ? response.data.pagination.totalPages : 0
          this.totalRecords = response.data.pagination ? response.data.pagination.totalRecords : 0
        })
        .catch(e => {
          if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
            return
          }
          this.fireNotification('error', "Error occurred", 5000)
        })
        .finally(() => {
          loader.hide()
        })
    },
    updateContractor(e) {
      e.preventDefault();
      let contractor = {
        firstName: this.contractor.firstName,
        lastName: this.contractor.lastName,
        idNumber: this.contractor.idNumber,
        phone: this.contractor.phone,
        email: this.contractor.email,
        address: this.contractor.address,
        status: "ACTIVE",
      };
      contractorService.update(localStorage.getItem('mid'), this.contractorId, contractor)
        .then(response => {
          this.contractor = response.data.data;
          document.getElementById('showEditContractorModal').click()
          this.retrieveContractors()
          Swal.fire({
            icon: 'success',
            title: 'Done',
            text: "Successfully updated",
            footer: '<a href="">Why do I have this issue?</a>'
          })
        })
        .catch(e => {
          if (e.response.status === 400) {
            Swal.fire({
              icon: 'warning',
              title: 'Failed',
              text: e.response.data.description,
              footer: '<a href="">Why do I have this issue?</a>'
            })
            return
          }
          console.log(e);
          if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
            return
          }
          this.fireNotification('error', "Oops", "Error occurred")
        });
    },
    deleteContractor(contractorId) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          contractorService.deleteContractor(localStorage.getItem('mid'), contractorId)
            .then(response => {
              this.success = true;
              this.retrieveContractors()
              Swal.fire({
                icon: 'success',
                title: 'Done',
                text: "Successfully deleted!",
                footer: '<a href="">Why do I have this issue?</a>'
              })
            })
            .catch(e => {
              if (e.response.status === 400) {
                Swal.fire({
                  icon: 'warning',
                  title: 'Failed',
                  text: e.response.data.description,
                  footer: '<a href="">Why do I have this issue?</a>'
                })
                return
              }
              console.log(e);
              if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
                return
              }
              this.fireNotification('error', "Error occurred", 5000)
            });
        }
      })
    },
    onPageChange(page) {
      this.currentPage = page
      this.retrieveContractors()
    },
    onChangeRecordsPerPage() {
      this.retrieveContractors()
    },
    fireNotification(icon, message, timeout) {
      Swal.fire({
        toast: true,
        width: 300,
        position: 'top-end',
        icon: icon,
        title: message,
        showConfirmButton: false,
        timer: timeout,
        timerProgressBar: true,
      })
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    windowWidth() {
      return this.$store.state.app.windowWidth
    },
    basedOnWindowWidth() {
      if (windowWidth < 768) {
        return true
      }
      return false
    }
  },
  watch: {
    windowWidth: function () {
      if (this.windowWidth < 768) {
        this.isMobileView = true
      }
      if (this.windowWidth >= 768 && this.windowWidth <= 1200) {
        this.isTabletView = true
      }
      if (this.windowWidth > 1200) {
        this.isDesktopView = true
      }
    }
  },
  async mounted() {
    if (!this.currentUser) {
      this.$router.push('/login')
      return
    }
    this.retrieveContractors();
  }
}
</script>
<style scoped>
:disabled {
  cursor: not-allowed;
}

.cards thead {
  display: none;
}

.cards tr {
  display: flex;
  flex-direction: column;

  margin-bottom: 5px !important;
  /*border: 1px solid navajowhite !important;*/
  border: 1px solid rgba(0, 0, 0, 0.1) !important;;
}

.cards tr > th {
  display: none;
}

.hide-on-mobile {
  display: none;
}

.cards tr > td::before {
  content: attr(col) '';
  font-weight: bold;
}

.book-button {
  color: white;
  background-color: #28a745;
  border-color: #28a745;
}

.book-button:hover {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/contractors/ContractorList.vue